export const ongoingColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Date',
  },
  {
    name: 'blocklistNumber',
    label: 'N. of blocklists',
  },
  {
    name: 'matches',
    label: 'Matches',
  },
  {
    name: 'result',
    label: 'Result',
  },
];

export const ongoingColumnsLabels = {};

export const ongoingDefaultSorter = {};

export const ongoingSchema = {};
